import { Banner } from '@dixa/lib-shared-habla';
import { useState } from 'react';

import styles from './floatingBanner.module.scss';

export function FloatingBanner(): JSX.Element | null {
  const [isBannerVisible, setIsBannerVisible] = useState(true);

  const onClose = () => {
    setIsBannerVisible(false);
  };

  if (!isBannerVisible) {
    return null;
  }

  return (
    <Banner
      className={styles.banner}
      variant="info"
      headline="You are inside a sub-flow node. Your main flow and all its nodes are safe."
      description={
        <span>
          Sub-flows act as branches that can be reused multiple times across
          your main flow. You can easily return to your main flow at any time
        </span>
      }
      onClose={onClose}
    />
  );
}
